<div *ngIf="busy">
  Running for a dropshot... give me a second...
</div>

<div *ngIf="!busy && allScores.length == 0">
  No matches have been recorded yet.
</div>
<div *ngIf="!busy && allScores.length > 0 " class="scores">
  <div *ngFor="let asc of allScores">
    {{asc.nameLong}}
    <table class="table table-bordered" [ngClass]="asc.nameShort">
      <thead>
        <tr>
          <td class="points">Points</td>
          <td>Player</td>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let score of asc.scores" [ngClass]="{'bold':player.id==score.opponent.id,'bold':player.doublesId==score.opponent.id}">
          <td class="points">{{score.points}}</td>
          <td>

            <!-- for now, the idea here is that we only let the user click/link to look at other team scores if -->
            <!-- they are doubles and looking at other doubles... or they are singles looking at other singles... -->
            <!-- because the whole algorithm for looking at OTHER players scores relies on singles/doubles of the current logged in user!?!?!-->
            <a *ngIf="asc.isDoubles == player.isDoubles" [routerLink]="['/player',score.opponent.id]">{{score.opponent.name}}</a>
            <span *ngIf="asc.isDoubles != player.isDoubles">{{score.opponent.name}}</span>

            &nbsp;
            <span style="font-size: 0.8em;">({{score.matchCount}})</span>
            <ng-container *ngIf="debug">&nbsp;&nbsp;&nbsp;{{score.opponent.id}}</ng-container>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>